import React, { ReactElement } from 'react'
import {
  Button,
  Flex,
  Grid,
  PandaButton,
  Text,
} from '@mindfulchefuk/design-system'
import Link from 'next/link'
import routesConfig from '@mindfulchefuk/config/routesConfig'
import { GiftCardImage } from '@mindfulchefuk/features/GiftCards/components/GiftCardImage'

type TConfirmation = {
  email: string
  recipientFirstName: string
  recipientLastName: string
  recipientEmail: string
  isLoggedInUser: boolean
  restartJourney: () => void
  sendGiftCardToRecipient: string
}

export const Confirmation = ({
  email,
  recipientFirstName,
  recipientLastName,
  recipientEmail,
  restartJourney,
  isLoggedInUser,
  sendGiftCardToRecipient,
}: TConfirmation): ReactElement => (
  <div>
    <Text as="h3" variant="heading-lg" mb={16}>
      Yay. Your gift card is on its way!
    </Text>
    <Text variant="body-sm" color="pepper" mb={16}>
      A confirmation has been sent to you at {email}
    </Text>
    <Grid
      templateColumns={{ base: '1fr', sm: '1fr 1fr' }}
      gap={20}
      align="flex-start"
      my={32}
    >
      <div>
        <Text variant="body-md-500-caps" mb={16}>
          Recipient Name
        </Text>
        <Text
          variant="body-md"
          mt={8}
          mb={16}
        >{`${recipientFirstName} ${recipientLastName}`}</Text>
        {sendGiftCardToRecipient === 'true' && (
          <>
            <Text variant="body-md-500-caps" mb={16}>
              Recipient Email Address
            </Text>
            <Text variant="body-md" mt={8} mb={16}>{`${recipientEmail}`}</Text>
          </>
        )}
      </div>

      <GiftCardImage />
    </Grid>
    <Flex direction="column">
      <Button
        mb={20}
        variant="secondary"
        size="large"
        onClick={restartJourney}
        fullWidth
      >
        Buy another giftcard
      </Button>
      {isLoggedInUser ? (
        <Link href={routesConfig.upcoming.pathname} passHref>
          <PandaButton variant="primary" size="large" fullWidth>
            Go to your account
          </PandaButton>
        </Link>
      ) : (
        <Link href={routesConfig.home.pathname} passHref>
          <PandaButton variant="primary" size="large" fullWidth>
            Go to HomePage
          </PandaButton>
        </Link>
      )}
    </Flex>
  </div>
)
